import { render, staticRenderFns } from "./UnmaskedDrawer.vue?vue&type=template&id=4fb5add0&scoped=true&"
import script from "./UnmaskedDrawer.vue?vue&type=script&lang=ts&"
export * from "./UnmaskedDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./UnmaskedDrawer.vue?vue&type=style&index=0&id=4fb5add0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb5add0",
  null
  
)

export default component.exports